// extracted by mini-css-extract-plugin
export default {"content__wrapper":"styles_content__wrapper__WoZDY","img__container":"styles_img__container__VlV7c"};